<template>
  <!-- Notas de tipos de tamaño (size):
    md: Tamaño medio / pequeño (se usa por defecto, esta en la mayoría de dialogos, utilizado con poco contenido)
    fs: Tamaño full screen (utilizado para panel de ayuda y licencia de uso)
    fs-space: Tamaño full screen (utilizado para wizard) con espacio
    lg: Tamaño grande para casos con mucho contenido (utilizado para panel de ayuda y licencia de uso, excepcional por control de altura)
    lg-fix-h: Tamaño grande con fix de altura, no gestiona height, necesita ajustarse un maximo dentro del componente que lo usa
   -->
  <transition name="tranOpacity">
    <div
      v-if="isOpen"
      class="modal-overlay"
      :class="[hiddenBackground ? 'modal-overlay-background-hidden' : '']"
      :style="styleImportant"
      @click="closeDialog"
    >
      <transition name="slideAside">
        <div class="container shadow-md" 
          :class="size === 'md' 
            ? 'container-width-md' 
            : size === 'fs'
            ? 'container-width-fs'
            : size === 'sh'
            ? 'container-sheet-style'
            : size == 'fs-space'
            ? 'container-width-fs-space'
            : size === 'fs-real'
              ? 'container-width-fs-real'
              : 'container-width-lg'"
          @click.stop 
          v-if="secondTransition"
          :ref="refNameContainer"
          role="dialog"
          aria-modal="true"
          :aria-label="ariaLabel"
          tabIndex="0">
          <div class="flex flex-col dark:bg-darkblue-900"
            :class="size === 'md'  
              ? 'overflow-y-auto h-full' 
              : (size !== 'lg-fix-h' && !isLower1024) || forzeHFull
                ? 'overflow-y-hidden h-full'
                : 'overflow-y-hidden'">
            <header class="sticky top-0 flex-none z-10">
              <slot name="header" />
            </header>
            <div class="d-flex flex-row bg-white dark:bg-darkblue-900"
              :class="size === 'md' 
                ? 'max-height-main h-full' 
                : (size !== 'lg-fix-h' && !isLower1024) || forzeHFull
                 ? 'h-full'
                 : ''">
              <slot name="main" />
            </div>
          </div>
          <footer v-if="footerActive" class="flex flex-col lg:flex-row items-center w-full lg:w-auto space-y-2 lg:space-y-0 lg:space-x-2 px-4 py-2 pb-4 bg-white dark:bg-darkblue-900">
            <slot name="footer" />
          </footer>
          <UtilKeys v-if="closable" @keyup.esc="closeDialog"/>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import UtilKeys from '@/components/utilities/UtilKeys'
export default {
  name: 'base-dialog-button',
  components: {
    UtilKeys
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
    },
    closable: {
      type: Boolean,
      default: true,
    },
    zindexImportant: {
      default: null
    },
    ariaLabel: {
      type: String,
      default: 'Diálogo'
    },
    refNameContainer: {
      type: String,
      default: 'baseDialogContainer'
    },
    hiddenBackground: {
      type: Boolean,
      default: false,
    },
    footerActive: {
      type: Boolean,
      default: true,
    },
    forzeHFull: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      secondTransition: true
    }
  },
  computed: {
    styleImportant () {
      if (this.zindexImportant) return 'z-index: ' + this.zindexImportant + '!important;'
      return ''
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
  },
  watch: {
    isOpen: {
      deep: true,
      immediate: true,
      handler: 'watchisOpenHandler'
    },
  },
  methods: {
    closeDialog: function () {
      if (this.closable) {
        if (this.isOpen) this.$emit('closeDialog')
      }
    },
    watchisOpenHandler: async function () {
      const self = this
      if (self.secondTransition) self.secondTransition = !self.secondTransition
      else {
        // self.secondTransition = !self.secondTransition
        setTimeout(() => {
          self.secondTransition = !self.secondTransition
        }, 100)
      }
      setTimeout(() => {
        if (self.isOpen) {
          setTimeout(() => {
            self.$refs[this.refNameContainer].focus()
          }, 100)
        }
      }, 500)

      // Focus trapping
      if (!this.disableFocusTrapping) this.focusTrapping()
    },
    focusTrapping () {
      // Focus trapping
      this.$nextTick(() => {
        if (this.isOpen) { 
          this.handleOpenModalDialogMixin(this.refNameContainer) 
        } else this.releaseFocusDialogMixin()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000088;
  z-index: 2020;
  overflow: auto;
}
.modal-overlay-background-hidden {
  background-color: var(--secondary-900)!important;
}
.container {
  left:0;
  right:0;

  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
  position: relative;

  min-width: 320px;
  z-index: 101;

  background: white;
}
.container-width-md{
  margin-top: 0;
  @apply lg:mt-36;
  width: 40%;
}
.container-width-lg{
  margin-top: 0;
  @apply lg:mt-36;
  width: 60%;
}
.container-width-fs{
  margin-top: 0;
  height: calc(100% - 64px);
  width: 100%;
}

.container-sheet-style{
  margin-top: 0;
  height: 100dvh;
  width: 45%;
}

.container-width-fs-space{
  margin-top: 80px;
  height: 65%;
  width: 75%;
}
.container-width-fs-real{
  margin-top: 0;
  height: 100%;
  width: 100%;
}

.slideAside-enter-active,
.slideAside-leave-active {
  transition: all 0.25s;
  transform: translateY(0%);
  opacity: 1;
}
.slideAside-enter,
.slideAside-leave-to {
  transition: all 0.25s;
  transform: translateY(-100%);
  opacity: 0;
}
.tranOpacity-enter-active,
.tranOpacity-leave-active {
  transition: all 0.25s;
  opacity: 1;
}
.tranOpacity-enter,
.tranOpacity-leave-to {
  transition: all 0.25s;
  opacity: 0;
}
.max-height-main{
  max-height: 400px;
}
</style>
